//#region libraries
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
//bootstrap
import { Container, Row, Col, Button, Form } from "react-bootstrap";
//styles
import { Colors } from "_styles";
//redux
import { useDispatch, useSelector } from "react-redux";
//custom components
import { SurveyQuestions } from "_components/organisms";
import { getReviewBooking, getReviewTask, getPaxQuestions, selectReviewTask, getSurveyById, selectSurveyById, selectedPassenger, setSelectedPassenger } from "_redux/slices/analytics/review-control-panel";
import { getAirportLogo } from "_redux/slices/analytics/reviews";
import { extractNameFromBookingId } from "_utils/functions";
import { translate } from "_components/organisms/feedback/surveys-utils";

//#endregion

const PassengerSurvey = () => {
    const { bookingId, taskId, iata, surveyId } = useParams();  // i added iata since we need to specify the task in which airport
    const multiplePaxs = taskId.includes("rampBooking") || taskId.includes("boarding") || taskId.includes("selfAllocatedTask") || taskId.includes("flightTask")
    //#region redux
    const dispatch = useDispatch();
    const task = useSelector(selectReviewTask);
    const passengerChecked = useSelector(selectedPassenger)
    const surveyById = useSelector(selectSurveyById);

    //#endregion

    //#region local state
    const [surveyStarted, setSurveyStarted] = useState(false)                               // initial screen
    const [selectedLanguage, setSelectedLanguage] = useState("en")                          // initial screen
    const [viewLanguageSelector, setViewLanguageSelector] = useState(false);                // holds value to show the language selector of the survey
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);               // window height
    const [showPaxList, setShowPaxList] = useState(false)
    const [paxList, setPaxList] = useState([]);

    //#endregion


    useEffect(() => {
        dispatch(setSelectedPassenger(null))
        // Only multi-pax tasks (ramp/boarding/selfAllocated/flightTask) need the task doc
        // for the passenger picker. Single-pax QR surveys don't — and the public client
        // can't read the tasks collection (Firestore rules), so skip the fetch for them.
        if (taskId && multiplePaxs) {
            dispatch(getReviewTask(taskId));
        }
        if (bookingId && !multiplePaxs) {
            dispatch(getReviewBooking(bookingId));
        }

    }, [])


    useEffect(() => {
        const data = { passenger: true, surveyId, language: selectedLanguage }
        dispatch(getPaxQuestions(data))

        const params = {
            iata,
            audience: taskId !== "email-survey" ? "passenger" : "email-survey"
        }
        dispatch(getSurveyById(params))
        dispatch(getAirportLogo(iata))

    }, []);


    // height resize
    useEffect(() => {
        const handleResize = () => {
            setViewportHeight(window.innerHeight);
        };

        // Set initial height
        handleResize();

        // Update height on resize
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {

        if (multiplePaxs) {
            const answeredPassengers = task.surveyInfo ? task.surveyInfo.surveys.map(s => s.bookingId) : [];
            const filterPax = task.passengers.filter(pax => !answeredPassengers.includes(pax.originalBookingId));
            const paxList = filterPax.map(pax => formatPaxList(pax.originalBookingId));
            if (paxList.length === 1) dispatch(setSelectedPassenger(paxList[0].value))
            if (paxList.length > 1) setShowPaxList(true);
            setPaxList(paxList)
        }
    }, [task])


    useEffect(() => {
        if (!Object.isObjectEmpty(surveyById)) {
            // check if surveyId has languages array and the length equals 2 it has both languages (Arabic, English)
            if (Array.isArray(surveyById?.languages) && surveyById?.languages?.length === 2) {
                // view the language selector and hide the QR code
                setViewLanguageSelector(true);
            } else if (Array.isArray(surveyById?.languages) && surveyById?.languages?.length === 1) {
                // if surveyId has languages array and the length equals 1 it has one language
                setViewLanguageSelector(false);
                setSelectedLanguage(surveyById?.languages?.[0]?.value);
            }
        }

    }, [surveyById]);

    const handleStartSurvey = () => {
        setSurveyStarted(true);
    }
    const handleGetPaxQuestions = (tempLang) => {
        const data = { passenger: true, surveyId, language: tempLang }
        dispatch(getPaxQuestions(data))
    }
    const formatPaxList = (originalBookingId) => {

        const paxName = extractNameFromBookingId(originalBookingId)
        return {
            value: originalBookingId,
            label: paxName
        }
    }

    const handleSelectLanguage = (lang) => {
        setSelectedLanguage(lang);
        setViewLanguageSelector(false);
        handleGetPaxQuestions(lang)
    }

    return (
        <Container style={{ height: `${viewportHeight}px`, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            {viewLanguageSelector
                ?
                <Container style={{ textAlign: "center", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                    <p style={{ fontSize: 24, color: Colors.PRM_LIGHT_BLUE, opacity: 0.8 }}>
                        Please select survey language
                    </p>
                    <div>
                        {surveyById?.languages.map(lang => {
                            return (
                                <Row key={lang.value}>
                                    <Col xs={12} style={{ marginBottom: "20px" }}>
                                        <Button variant="primary" onClick={() => handleSelectLanguage(lang.value)} style={{ width: "100%" }}>{lang.label}</Button>
                                    </Col>
                                </Row>
                            )
                        })}

                    </div>

                </Container>
                :
                <>
                    {!surveyStarted ? (
                        <>
                            <Container style={{ textAlign: "center", direction: selectedLanguage === 'ar' ? 'rtl' : 'ltr' }}>
                                <Row className="p-3">
                                    <Col xs={12}>
                                        <p style={{ fontSize: 24, color: Colors.PRM_LIGHT_BLUE, opacity: 0.8 }}>
                                            {translate('title', selectedLanguage)}
                                        </p>

                                        {task?.surveyInfo?.status === "completed" ? (
                                            <p style={{ fontSize: 18, marginTop: "20px", color: "green" }}>
                                                {translate('surveyCompleted', selectedLanguage)}
                                            </p>
                                        ) : (
                                            <p style={{ fontSize: 18, marginTop: "20px" }}>
                                                {translate('subTitle', selectedLanguage)}
                                            </p>
                                        )}
                                    </Col>
                                </Row>
                            </Container>

                            {showPaxList && (
                                <Container style={{ textAlign: "center" }}>
                                    <Row>
                                        {paxList.map((pax) => (
                                            <div className='d-flex align-items-center' key={pax.value}>
                                                <Form.Check inline type="radio" checked={passengerChecked == pax.value} onChange={() => dispatch(setSelectedPassenger(pax.value))} />
                                                <Form.Check.Label style={{ marginTop: ".25em" }}>{pax.label}</Form.Check.Label>
                                            </div>
                                        ))}
                                    </Row>
                                </Container>
                            )}

                            <Container style={{ textAlign: "center" }}>
                                <Row>
                                    <Col xs={12} style={{ marginBottom: "20px" }}>
                                        <Button
                                            variant="primary"
                                            onClick={handleStartSurvey}
                                            style={{ width: "100%" }}
                                            disabled={task?.surveyInfo?.status === "completed" || (showPaxList && !passengerChecked)}
                                        >
                                            {translate('startBtn', selectedLanguage)}
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </>
                    ) : (
                        <SurveyQuestions iata={iata} language={selectedLanguage} taskId={taskId} multiplePaxs={multiplePaxs} />
                    )}
                </>
            }
        </Container>
    )
}

export default PassengerSurvey;
